import React from 'react';
import '../../App.css';

function Ministries() {
  return (
    <>
      <div className='hero-container b half'>
        <h1></h1>
      </div>
    </>
  );
}

export default Ministries;